import { CommApiInstance } from "Utils/CommApiInstance";

const CtntTop5InqApi = async (
    gameSvcCd:string|null,
    ctntKindCd:string|null,
    
) => {
    return await CommApiInstance.post(`${gameSvcCd}/ctnt/${ctntKindCd}/top`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default CtntTop5InqApi;